import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { forkJoin, of, take } from 'rxjs';
import { UserTypeFlag } from 'wre-authlib';
import { UserType } from 'wre-authlib';
import { LookupUser } from 'wre-authlib';
import { AuthorisationService } from 'wre-authlib';

@Component({
  selector: 'wtw-user-lookup-wrapper',
  template: `
    <wtw-user-lookup
      [labelText]="labelText"
      [inputId]="inputId"
      [inputName]="inputName"
      [isHorizontal]="isHorizontal"
      [list]="searchResult"
      [loading]="loading"
      [control]="control"
      [placeholderValue]="placeholderValue"
      [displayBadge]="displayBadge"
      [isInvalid]="isInvalid"
      [isDisabled]="isDisabled"
      [isMultiSelect]="isMultiSelect"
      [readOnly]="readOnly"
      [noSearchResultText]="noSearchResultText"
      [emptyListText]="emptyListText"
      (searchEvent)="searchUsers($event)">
    </wtw-user-lookup>
  `,
  standalone: false
})
export class UserLookupWrapperComponent {
  @Input() isMultiSelect: boolean = true;
  @Input() displayBadge: boolean = true;
  @Input() control = new FormControl();
  @Input() inputId = 'userLookupId';
  @Input() placeholderValue = 'Search user...';
  @Input() isDisabled = false;
  @Input() isInvalid?: boolean;
  @Input() labelText?: string;
  @Input() inputTabIndex?: string;
  @Input() inputName?: string;
  @Input() isHorizontal: boolean = false;
  @Input() userTypes: UserTypeFlag = UserTypeFlag.All;
  @Input() applicationName: string = 'wre-gateway';
  @Input() readOnly = false;
  @Input() emptyListText = 'The list Emtpy/ReadOnly';
  @Input() noSearchResultText = 'No user found';

  loading = true;
  searchResult: LookupUser[] = [];

  constructor(private authorisationService: AuthorisationService) {}

  searchUsers(searchTerm: string) {
    this.loading = true;
    this.searchResult = [];

    forkJoin([
      (this.userTypes & UserTypeFlag.InternalUsers) === UserTypeFlag.InternalUsers
        ? this.authorisationService.getUsersDetailsStartsWith(
            this.applicationName,
            UserType.InternalUsers,
            searchTerm,
          )
        : of([]),
      (this.userTypes & UserTypeFlag.AdGroups) === UserTypeFlag.AdGroups
        ? this.authorisationService.getUsersDetailsStartsWith(
            this.applicationName,
            UserType.AdGroups,
            searchTerm,
          )
        : of([]),
      (this.userTypes & UserTypeFlag.ExternalUsers) === UserTypeFlag.ExternalUsers
        ? this.authorisationService.getUsersDetailsStartsWith(
            this.applicationName,
            UserType.ExternalUsers,
            searchTerm,
          )
        : of([]),
      (this.userTypes & UserTypeFlag.ServicePrinciples) === UserTypeFlag.ServicePrinciples
        ? this.authorisationService.getUsersDetailsStartsWith(
            this.applicationName,
            UserType.ServicePrinciples,
            searchTerm,
          )
        : of([]),
    ])
      .pipe(take(1))
      .subscribe(([internalUsers, adGroups, externalUsers, servicePrinciples]) => {
        this.loading = false;
        this.searchResult = [
          ...internalUsers,
          ...adGroups,
          ...externalUsers,
          ...servicePrinciples,
        ].map((lookupUser) => ({
          ...lookupUser,
          displayName: lookupUser.displayName.replace('(AJ Gallagher)', '').trim(),
        }));
      });
  }
}
